

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { VisitorsRecord } from '@/core/data/sets/VisitorsRecord';
import { Common } from '@/core/Common';
import { FView } from '@/core/FView';
import { DataType } from '@/core/data/DataType';

@Component ({
  components: {
      
  },
})
export default class extends Vue {
    getDataSet(): VisitorsRecord[] {
        return FView.Get().dataManager.GetDataset<VisitorsRecord>(DataType.VisitorsDaily);
    }

    formatDate(dt: string): string {
      return Common.FormatDate(dt);
    }

    getColor(dt: string) {
        return Common.IsWeekend(dt) ? "#C11" : "#111"
    }
}
